module.exports = __webpack_public_path__ + "img/selfiecardexample.1edffb2f.png";